import styled, { css } from 'styled-components';

export const Layout = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacer-M);
    margin-top: var(--spacer-S);
`;

export const StepCards = styled.div`
    display: flex;
    gap: var(--spacer-S);
    flex-wrap: wrap;
`;

export const StepCard = styled.div<{ $isActive: boolean }>`
    min-width: 140px;
    padding: var(--spacer-S);
    border-radius: 12px;
    border: var(--border-thin) solid var(--surface-border-subtle);
    background: var(--brand-accent);

    ${({ $isActive }) => $isActive && css`
        border-color: var(--brand-primary);
        background: var(--surface-brand-soft);
    `}
`;

export const StepNumber = styled.div`
    font-size: 0.8rem;
    color: var(--text-muted);
`;

export const StepTitle = styled.div`
    font-weight: 600;
    color: var(--text-strong);
`;

export const ActionsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: var(--spacer-S);
    flex-wrap: wrap;
`;

export const MappingHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacer-S);
    flex-wrap: wrap;
`;

export const MappingActions = styled.div`
    display: flex;
    gap: var(--spacer-S);
`;

export const HintText = styled.div`
    color: var(--text-muted);
`;

export const FieldKeyText = styled.div`
    color: var(--text-muted);
    font-size: 0.85rem;
`;

export const MutedText = styled.div`
    color: var(--text-muted);
    font-size: 0.9rem;
`;

export const ImportCard = styled.div`
    border: var(--border-thin) solid var(--surface-border-subtle);
    background: linear-gradient(180deg, var(--surface-brand-soft) 0%, var(--brand-accent) 100%);
    border-radius: 14px;
    padding: var(--spacer-M);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-S);
`;

export const ImportHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--spacer-S);
    flex-wrap: wrap;
`;

export const ImportTitle = styled.div`
    font-weight: 600;
    color: var(--text-strong);
`;

export const StatusText = styled.div`
    color: var(--text-muted);
    font-size: 0.9rem;
`;

export const ImportProgressRow = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacer-XS);
`;

export const MappingTableBody = styled.tbody`
    &&& > tr > td {
        vertical-align: top;
    }
`;
